import { ProfileTitledWriterSetting } from 'open-modules/cbcrc/feature/profile/profile-titled-writer';
import { profileFieldsProperty } from 'structure/profile';
import { CLICK, componentWithVariants, demoFile, INPUT, story, variant } from 'system/demo';

demoFile('open-modules/cbcrc/feature/profile/profile-titled-writer');

componentWithVariants('ProfileTitledWriterSetting', ProfileTitledWriterSetting, {}, [
    variant(
        'Set a title',
        {
            instanceKey: 'a',
            state: {
                personaKey: 'a',
                roles: ['Owner'],
                serverCall: {
                    profile: {
                        update: async ({ datastore, updates, preview }) => {
                            datastore.updateGlobalProperty(profileFieldsProperty, updates);
                            datastore.updateObject('persona', 'a', preview);
                            return Promise.resolve();
                        },
                    },
                },
            },
        },
        [story('Input a title', [INPUT('profile-title', 'Journalist'), CLICK('Is titled writer'), CLICK('Update')])],
    ),
    variant('Non-admin user'),
]);
